export class GetRoleComponentSitemapRequest {
  roleComponentId: number;
}
